import moment from 'moment';

import { type FormValues } from '../types';

export const useDeliveredState = (initialFormValues: FormValues) => {
	const [intervalStart, intervalEnd] = initialFormValues.intervals || [];

	return {
		intervalsDisabled: intervalStart && intervalEnd && !moment(intervalStart).isSame(moment(intervalEnd), 'day')
	};
};
